import React from 'react';
import { Checkbox, Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import * as fieldListStyle from './FieldListStyle';

class FieldCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: window.innerWidth,
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({ screenWidth: window.innerWidth });
  }

  handleCheckBoxChange = () => {
    this.props.handleCheckbox(this.props.field.fieldId);
  };

  render() {
    const { field, checked, disable, fieldMasterData } = this.props;
    const [fieldCropName] =
      field.cropId !== null
        ? (fieldMasterData.cropList ? fieldMasterData.cropList.filter((crop) => crop.id === field.cropId) : '')
        : (fieldMasterData.cropList ? fieldMasterData.cropList.filter((crop) => crop.id === 0) : '');

    return (
      <li
        className="show-checkbox list-item full-width"
        key={field.fieldId}
        style={{
          borderBottom: '1px solid #BEC8C9',
          padding: '0px',
          margin: '0px',
        }}
      >
        <Box
          style={{
            display: 'flex',
            padding: '8px 0px',
            width: '100%',
            alignItems: 'center',
            gap: '16px',
            flex: '1 0 0',
            alignSelf: 'stretch',
            height: '72px',
          }}
        >
          <Checkbox
            checked={checked}
            id={field.fieldId}
            onChange={this.handleCheckBoxChange}
            sx={{
              color: '#000',
              '&.Mui-checked': { color: '#00696D' },
            }}
          />

          <Link
            className={`field-list-item-link ${disable && 'disabled'}`}
            to={`/managefields/${field.fieldId}`}
            style={{
              textDecoration: 'none',
              border: 'none',
              boxShadow: 'none',
              background: 'none',
              width: '100%',
              display: 'flex',
              flex: '1 0 0',
              alignItems: 'center',
              gap: '16px',
              padding: '0px',
            }}
          >
            {/* Field Name */}
            <Box style={{ flex: 2, minWidth: 0 }}>
              {field.fieldSize && (
                <Typography style={fieldListStyle.listRowSubItem}>
                  {field.fieldSize} daa
                </Typography>
              )}
              <Typography
                sx={{
                  ...fieldListStyle.listRowItem,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block',
                }}
                title={field.displayName}
              >
                {field.displayName}
              </Typography>
            </Box>

            {/* Crop Name */}
            <Box style={{ flex: 1, minWidth: 0 }}>
              {field.age ? (
                <Typography style={fieldListStyle.listRowSubItem}>{field.age} år</Typography>
              ) : (
                '-'
              )}
              {fieldCropName ? (
                <Typography
                  sx={{
                    ...fieldListStyle.listRowItem,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                  }}
                  title={fieldCropName.name}
                >
                  {fieldCropName.name}
                </Typography>
              ) : (
                ''
              )}
            </Box>

            {/* Yield */}
            <Box style={{ flex: 1 }}>
              <Typography style={fieldListStyle.listRowSubItem}>
                {field.harvests ? `${field.harvests} slåtter` : '-'}
              </Typography>
              <Typography style={fieldListStyle.listRowItem}>
                {field.yieldGoal ? `${field.yieldGoal} kg ts/daa` : '-'}
              </Typography>
            </Box>

            {/* Temp Sum */}
            <Box style={{ flex: 1 }}>
              {field.currentTempSum ? (
                <Typography style={fieldListStyle.listRowItem}>{field.currentTempSum}</Typography>
              ) : (
                '-'
              )}
            </Box>
          </Link>
        </Box>
      </li>
    );
  }
}

export default injectIntl(FieldCard);